import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { TagListDto } from '../../dtos/tag-list.dto';
import { TagSearchDto } from '../../dtos/tag-search.dto';
import { createTagsSchema } from '../schemas/create-tags.schema';

/**
 * Validates the tags array object.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const isValidTags = (
	tags: TagListDto[] | TagSearchDto[] | null,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check
	if (!tags || tags.length === 0) {
		return {
			isValid: true,
		};
	}

	// Validate
	const { error } = createTagsSchema().validate(tags, {
		abortEarly,
	});

	// Check
	if (error) {
		return {
			isValid: false,
			errors: error.details?.map((e) => e.message),
		};
	}

	// Return
	return { isValid: true };
};
